<template>
  <vs-popup class="user-edit-popup" id="popup" title="CREATE CHANNEL PARTNER" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createStaffForm.email" name="email" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createStaffForm.first_name" name="first_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="createStaffForm.last_name" name="last_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Name</small>
                <vs-input v-model="createStaffForm.company_name" name="company_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :clearable="false" label="name" v-model="createStaffForm.country"
                  :reduce="option => option.name" :options="countryCodes">
                  <template v-slot:option="option">
                    <span>{{ option.name }} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="start_date" name="start_date" rules="required" v-slot="{ errors }">
                <small class="label">Account Handler</small>
                <v-select :clearable="false" label="first_name" v-model="createStaffForm.account_handler_id"
                  :reduce="option => option.id" :options="account_handlers">
                  <template v-slot:option="option">
                    <span>{{ option.first_name }} - {{ option.email }} </span>
                  </template>
                </v-select>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3" v-if="tenant_id">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="date_introduced" name="date_introduced" rules="required" v-slot="{ errors }">
                <small class="label">Date Introduced </small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden"
                  v-model="createStaffForm.agreement.date_introduced" placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                  v-model="createStaffForm.agreement.date_introduced" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="percent" name="percent" rules="required" v-slot="{ errors }">
                <small class="label">Commition Percentage (%)</small>
                <vs-input v-model="createStaffForm.agreement.percent" name="percent" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3" v-if="tenant_id">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="start_date" name="start_date" rules="required" v-slot="{ errors }">
                <small class="label">Agreement Start Date </small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden"
                  v-model="createStaffForm.agreement.start_date" placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                  v-model="createStaffForm.agreement.start_date" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="end_date" name="end_date" rules="required" v-slot="{ errors }">
                <small class="label">Agreement End Date</small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden" v-model="createStaffForm.agreement.end_date"
                  placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="createStaffForm.agreement.end_date"
                  placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="comment" name="comment" rules="" v-slot="{ errors }">
                <small class="label">Comments</small>
                <vs-textarea class="mb-0" v-model="createStaffForm.comment" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner');
const CurrencyRepository = RepositoryFactory.get('currency');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const CountryCodeRepository = RepositoryFactory.get('countryCode');
const UserRepository = RepositoryFactory.get('user');
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

function initialState() {
  return {
    open: false,
    createStaffForm: {
      agreement: {
        date_introduced: '',
        start_date: '',
        end_date: '',
        percent: ''
      }
    },
    countryCodes: [],
    account_handlers: [],
    tenant_id: null
  }
}

export default {
  name: 'CreateChannelPartnerPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
    flatPickr,
  },

  methods: {
    async openPopup() {
      try {
        Object.assign(this.$data, initialState())
        this.tenant_id = this.$route.params.id
        this.$refs.form.reset();
        await this.loadCountryCodes()
        await this.fetchUsers()
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },

    async onClickCreateStaffUser() {
      const vue = this;
      this.$vs.loading()
      try {
        this.createStaffForm.agreement.percent = Number(this.createStaffForm.agreement.percent).toFixed(2)
        await ChannelPartnerRepository.createChannelPartner(this.createStaffForm, this.tenant_id)
        this.showSuccessMessage('Channel partner created successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async loadCountryCodes() {
      const { data } = await CountryCodeRepository.get()
      this.countryCodes = data.data
    },
    async fetchUsers() {
      const { data } = (await UserRepository.get(1, '', 150, '')).data
      this.account_handlers = data
    },
    onClickReset() {
      this.createStaffForm = {}
    }
  },
}
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  height: 100%;
}

.video-wrapper video {
  object-fit: cover;
  width: 100%;
  height: 100%;

}

.image-wrapper {
  width: 100%;
  height: 75%;
}
</style>
